import { instance } from './ApiRequest';
import { PAYMENT_GATEWAY_CONFIG_GET, PAYMENT_GATEWAY_CONFIG_UPDATE } from 'constants/constants';

// Phase R6.5 (Admin-Configurable Payment Gateway) — a dedicated module for this new backend surface,
// following the same "one small module per related API surface" convention LanguageConfigService.js
// established, rather than folding this into the large legacy AdminService.js. Both calls are
// Global-Admin-gated on the backend; nothing here is candidate-facing.
let _PaymentGatewayConfigService = {
    async getPaymentGatewayConfig() {
        return await instance.get(PAYMENT_GATEWAY_CONFIG_GET);
    },
    async updatePaymentGatewayConfig(model) {
        return await instance.post(PAYMENT_GATEWAY_CONFIG_UPDATE, model);
    }
};

export default _PaymentGatewayConfigService;
